/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchannelwhatsappstatus4Inputs */

const en_aiflowchannelwhatsappstatus4 = /** @type {(inputs: Aiflowchannelwhatsappstatus4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp status`)
};

const de_aiflowchannelwhatsappstatus4 = /** @type {(inputs: Aiflowchannelwhatsappstatus4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp Status`)
};

/**
* | output |
* | --- |
* | "WhatsApp status" |
*
* @param {Aiflowchannelwhatsappstatus4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchannelwhatsappstatus4 = /** @type {((inputs?: Aiflowchannelwhatsappstatus4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchannelwhatsappstatus4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchannelwhatsappstatus4(inputs)
	return de_aiflowchannelwhatsappstatus4(inputs)
});
export { aiflowchannelwhatsappstatus4 as "aiFlowChannelWhatsappStatus" }